export default {
	"6c62e638f52d4c776ec062ea32234985": "支付寶掃碼簽約",
	"33cc31ef12300116a075383071d575bf": "前往支付寶簽約",
	"b8a0a775103ed39c38f92a1f102888cd": "取消支付"
}
